import { IconButton, Tooltip } from "@mui/material"
import AttachFileIcon from "@mui/icons-material/AttachFile";

interface AttachProps {
    handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}
const Attach: React.FC<AttachProps> = ({ handleFileInputChange }) => {
    return (
        <Tooltip title="Bild anhängen (.jpeg, .jpg, .webp, .gif, .png)">
        <IconButton component="label">
          <AttachFileIcon />
          <input
            type="file"
            accept=".jpeg,.jpg,.webp,.gif,.png"
            onChange={handleFileInputChange}
            style={{ display: "none" }}
          />
        </IconButton>
      </Tooltip>
    )
}
export default Attach;